var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42418 3.91306C3.35984 3.91343 3.29606 3.9011 3.23649 3.87677C3.17693 3.85244 3.12275 3.8166 3.07707 3.77129L0.143776 0.83799C0.0517179 0.745932 0 0.621073 0 0.490883C0 0.360693 0.0517179 0.235835 0.143776 0.143776C0.235835 0.0517179 0.360693 0 0.490883 0C0.621073 0 0.745931 0.0517179 0.83799 0.143776L3.42418 2.73486L6.01037 0.148665C6.10389 0.0685734 6.2242 0.0267219 6.34724 0.0314744C6.47028 0.0362269 6.58699 0.0872334 6.67406 0.174301C6.76113 0.261368 6.81213 0.378083 6.81688 0.501124C6.82164 0.624164 6.77979 0.744466 6.69969 0.83799L3.7664 3.77129C3.67534 3.8616 3.55243 3.91252 3.42418 3.91306Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.5d40cadbd6ff61868717c3cbabf60640.svg";
export { ForwardRef as ReactComponent };